import { LETTRAGE_ETAT } from '@/configuration/lettrageConf';

export default function formatEtatLettrage(etatLettrage) {
  const etat = LETTRAGE_ETAT.find((el) => {
    return el.etat === etatLettrage;
  });
  return etat ? etat.libelle : '';
}
